import React, { useState, useEffect } from 'react';
import axios from 'axios'
import Select from 'react-select';
import './form.css';

import { AddRevenue } from '../../Redux/action/revenueAction';
import { toast } from 'react-toastify';

import { allLocationWithShortName, dataUser, spocLocationDetailsZoho } from '../Helpers/util';
import { getLocationNameById } from '../../utils/getLocationNameById';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from "dayjs";
import AntDTimePicker from '../Common/AntDDateTimePicker/AntDTimePicker';


const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName()

class PublicWorking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: '',
      location1: '',
      locationData: [],
      locationNew: [],
      locationId: null,
      locationError: '',
      dateError: '',
      switchOnTimeError: '',
      switchOffTimeError: '',
      paxError: '',
      pax: null,

      purpose: '',
      notes: '',
      budget: '',
      company_id: UserObj ? UserObj.company_id : null,
      userid: UserObj ? UserObj.rec_id : null,
      email: UserObj ? UserObj.email : null,
      fb: '',
      date: '',
      switchOnTime: null,
      switchOffTime: null,
      func: [{ fandb: 'lunch', bgt: '1' }, { fandb: 'snack', bgt: '2' }],
      files: null,
      attachmentError: '',
      btnStatus: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    };
  }


  changeSelect = (e) => {
    if (!e) {
      this.setState({
        location: null,
        location1: "",
        locationId: "",
        locationError: "",
      });
      return;
    }

    this.setState({
      location: e,
      location1: String(e.label),
      locationId: e.value,
      locationError: "",
    });
  };

  onPaxChange = e => {
    this.setState({
      pax: e?.target?.value,
      paxError: null,
    });
  };

  onDateChange = e => {
    this.setState({
      date: e.target.value,
      dateError: '',
    });
  };
  onDateChange1 = e => {
    const switchOnTime = e.target.value;
    this.setState({
      switchOnTime,
      switchOnTimeError: '',
    });

    // Validate switch off time if it's already set
    if (this.state.switchOffTime && switchOnTime >= this.state.switchOffTime) {

      toast.error("Switch On Time cannot be after or equal to Switch Off Time");
    }
  };
  onDateChange2 = e => {
    const switchOffTime = e.target.value;

    // Check if Switch On Time is selected
    if (!this.state.switchOnTime) {
      this.setState({
        switchOffTimeError: "Please select Switch On Time first"
      });
      toast.error("Please select Switch On Time first");
    } else {
      // Update the state and then validate using a callback
      this.setState({ switchOffTime }, () => {
        const { switchOnTime } = this.state;

        // Validate that Switch Off Time is after Switch On Time
        if (switchOnTime && switchOffTime <= switchOnTime) {
          this.setState({
            switchOffTimeError: "Switch Off Time must be after Switch On Time"
          });
          toast.error("Switch Off Time must be after Switch On Time");
        } else {
          this.setState({ switchOffTimeError: '' }); // Clear the error if validation passes
        }
      });
    }
  };
  onNotes = e => {
    this.setState({
      notes: e?.target?.value,
      noteError: '',
    });
  };


  onSwitchOnTimeChange = (time) => {
    this.setState({
      switchOnTime: time,
      switchOnTimeError: '',
    });

    // Validate existing end time
    if (this.state.switchOffTime && time && !this.state.switchOffTime.isAfter(time)) {
      toast.error("Switch On Time must be before Switch Off Time");
    }
  };



  onSwitchOffTimeChange = (time) => {
    const { switchOnTime } = this.state;

    if (!switchOnTime) {
      this.setState({ switchOffTimeError: "Please select Switch On Time first" });
      toast.error("Please select Switch On Time first");
      return;
    }

    if (!time.isAfter(switchOnTime)) {
      this.setState({ switchOffTimeError: "Switch Off Time must be after Switch On Time" });
      toast.error("Switch Off Time must be after Switch On Time");
      return;
    }

    this.setState({
      switchOffTime: time,
      switchOffTimeError: '',
    });
  };



  disabledEndTime = () => {
    const { switchOnTime } = this.state;
    if (!switchOnTime) return {};

    return {
      disabledHours: () => {
        const hours = [];
        for (let i = 0; i < switchOnTime.hour(); i++) {
          hours.push(i);
        }
        return hours;
      },
      disabledMinutes: (selectedHour) => {
        if (selectedHour === switchOnTime.hour()) {
          const minutes = [];
          for (let i = 0; i < switchOnTime.minute(); i++) {
            minutes.push(i);
          }
          return minutes;
        }
        return [];
      },
    };
  };


  componentDidMount() {
    var LocationSpoc = JSON.parse(userDataLocal12);
    let locationShort = JSON.parse(locationWithShortName)
    this.setState({ locationNew: locationShort })
    this.setState({
      locationData: LocationSpoc,
    });
  }


  handleFile(e) {

    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
      });
    }

    // Getting the files from the input
    this.setState({ files: e.target.files });

    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    }
    else if (e.target.files.length <= 2) {
      this.setState({ attachmentError: "" });
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    let files = this.state.files;
    let formData = new FormData();

    // Append files to formData
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
    }

    // Initialize error flags
    let locationError = '';
    let dateError = '';
    let switchOnTimeError = '';
    let switchOffTimeError = '';
    let attachmentError = '';

    // Validate Location
    if (this.state.location === '') {
      locationError = "Location can't be empty";
    }

    // Validate Date
    if (this.state.date === '') {
      dateError = "AC switch on date can't be empty";
    }

    // Validate Switch On Time
    if (this.state.switchOnTime === '') {
      switchOnTimeError = "Switch On Time can't be empty";
    }

    // Validate Switch Off Time
    if (this.state.switchOffTime === '') {
      switchOffTimeError = "Switch Off Time can't be empty";
    } else if (this.state.switchOnTime && this.state.switchOffTime <= this.state.switchOnTime) {
      switchOffTimeError = "Switch Off Time must be after Switch On Time";
    }

    // Validate File Attachments
    if (this.state.files && this.state.files.length > 2) {
      attachmentError = "Attachment can't be more than 2";
    }

    // Set error states
    this.setState({
      locationError,
      dateError,
      switchOnTimeError,
      switchOffTimeError,
      attachmentError,
    });

    // Show error toasts


    if (switchOnTimeError) toast.error(switchOnTimeError);
    if (switchOffTimeError) toast.error(switchOffTimeError);


    // If there are no errors, proceed with form submission
    if (!locationError && !dateError && !switchOnTimeError && !switchOffTimeError && !attachmentError) {
      e.currentTarget.disabled = true;
      let param = {};
      let common_param = {
        company_id: this.state.company_id,
        spoc_id: this.state.userid,
        email: this.state.email,
        category: 'Working_on_a_public_holiday',
        company_name: UserObj ? UserObj.company_name : null,
      };
      let body_param = {
        ac_start_date: this.state.date,
        ac_start_time: this.state.switchOnTime
          ? this.state.switchOnTime.format("HH:mm")
          : "",
        ac_end_time: this.state.switchOffTime
          ? this.state.switchOffTime.format("HH:mm")
          : "",
        notes: this.state.notes,
        location_name: this.state.location1,
        // Additional parameters as needed
      };
      param.common_param = common_param;
      param.body_param = body_param;
      // AddRevenue(param, formData);
      // this.setState({
      //   btnStatus: false,
      // });
      // e.currentTarget.disabled = false
      AddRevenue(param, (success, message) => {
        if (success) {
          toast.success(message);
          this.resetValue();
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
        this.setState({ btnStatus: false });
        e.currentTarget.disabled = false;
      });
    }
  };
  resetValue = () => {
    this.setState({
      date: '',
      switchOnTime: '',
      switchOffTime: '',
      notes: '',
      location: '',
      pax: '',
      locationError: '',
      dateError: '',
      switchOnTimeError: '',
      switchOffTimeError: '',
      paxError: '',
      attachmentError: '',


    });
    this.setState({
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    })
  };

  render() {
    return (
      <>

        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Location <span className="Required">*</span></label>
              <SwSelect
                name="location"
                id="public-working-location-select"
                onChange={this.changeSelect}
                value={this.state.location}
                options={this.state.locationData}
                isClearable={false}
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.locationError}
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 ">
            <div className="SwFormGroup">
              <label className="SwFormLabel">AC switch on Date <span className="Required">*</span></label>
              <AntDDatePicker
                type="single"
                name="date"
                format="DD/MM/YYYY"

                /* disable past dates */
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }

                value={this.state.date ? dayjs(this.state.date) : null}

                onChange={(date) => {
                  this.setState({
                    date: date ? date.format("YYYY-MM-DD") : null
                  });
                }}
              />

              <span className="SwTextDanger SwTextSmall">
                {this.state.dateError}
              </span>
            </div>
          </div>

        </div >

        <div className="row">
          <div className="col-md-6  ">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Switch On Time <span className="Required">*</span></label>
              <AntDTimePicker
                name="switchOnTime"
                value={this.state.switchOnTime}
                onChange={this.onSwitchOnTimeChange}
                format="HH:mm"
                placeholder="Switch On Time"
                allowClear={false}
              />

              <span className="SwTextDanger SwTextSmall">
                {this.state.switchOnTimeError}
              </span>


            </div>
          </div>
          <div className="col-md-6  ">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Switch Off Time <span className="Required">*</span></label>
              <AntDTimePicker
                name="switchOffTime"
                value={this.state.switchOffTime}
                onChange={this.onSwitchOffTimeChange}
                format="HH:mm"
                placeholder="Switch Off Time"
                allowClear={false}
                disabledTime={this.disabledEndTime}
              />

              <span className="SwTextDanger SwTextSmall">
                {this.state.switchOffTimeError}
              </span>

            </div>
          </div>

        </div>

        <div className="row">
          <div className="col-md-12 mt-2">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Notes</label>
              <SwTextArea
                rows="4"
                value={this.state.notes}
                onChange={this.onNotes}
                id="public-working-notes"
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.noteError}
              </span>
            </div>
          </div>
        </div>


      </>
    );
  }
}

export default PublicWorking;
